// tslint:disable: completed-docs
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OaoCustomPopupModule } from './custom-modals/oao-custom-modals.module';
// eslint-disable-next-line max-len
import { OaoAccountServiceModelLoaderComponent } from './components/oao-account-service-model-loader/oao-account-service-model-loader.component';
import { OaoCheckingAndSavingAccountComponent } from './components/oao-checking-saving-accounts/oao-checking-saving-account.component';
import { OaoIncludedAccountComponent } from './components/oao-included-account/oao-included-account.component';
import { OaoOtherAccountComponent } from './components/oao-other-account/oao-other-account.component';
import { OaoOtherAccountMembershipServiceComponent } from './components/oao-other-member-services/oao-other-member-services.component';
import { OaoRetirementAccountComponent } from './components/oao-retirement-account/oao-retirement-account.component';
import { OaoShareCertificatesAccountComponent } from './components/oao-share-certificates-account/oao-share-certificates-account.component';
import { OaoAccountsServiceReviewComponent } from './components/review/oao-accounts-services-review/oao-accounts-services-review.component';
import { OaoAdditionalQuesReviewComponent } from './components/review/oao-additional-ques-review/oao-additional-ques-review.component';
import { OaoBeneficiaryReviewComponent } from './components/review/oao-beneficiary-review/oao-beneficiary-review.component';
import { OaoEligibilityReviewComponent } from './components/review/oao-eligibility-review/oao-eligibility-review.component';
import { OaoEligibilityComponent } from './custom-pages/oao-eligibility/oao-eligibility.component';
// eslint-disable-next-line max-len
import { RequestedDocumentReviewComponent } from './components/review/oao-requested-document-review/oao-requested-document-review.component';
import { PluginsModule } from '@cudirect/shared-ui-library/plugins';
import { EcpSharedModule } from '@workflow/ecp-shared/shared.module';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';

const customPages = [OaoEligibilityComponent];

const reviewComponents = [
  OaoAccountsServiceReviewComponent,
  OaoAdditionalQuesReviewComponent,
  OaoBeneficiaryReviewComponent,
  OaoEligibilityReviewComponent,
  RequestedDocumentReviewComponent
];

const components = [
  OaoAccountServiceModelLoaderComponent,
  OaoCheckingAndSavingAccountComponent,
  OaoIncludedAccountComponent,
  OaoOtherAccountComponent,
  OaoOtherAccountMembershipServiceComponent,
  OaoRetirementAccountComponent,
  OaoShareCertificatesAccountComponent,
  customPages,
  reviewComponents
];

@NgModule({
  declarations: [...components],
  exports: [...components, OaoCustomPopupModule],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    EcpSharedModule,
    PageSharedModule,
    DynamicPipeModule,
    DynamicRenderSharedModule,
    OaoCustomPopupModule,
    PluginsModule
  ]
})
export class OaoModule {}
